import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }
/* Layout */
import Layout from '@/layout'
import login from '@/views/login/index'
import chapter from '@/views/system/chapter'
import professionChapter from '@/views/system/professionChapter'
import question from '@/views/resource/question'
import courseware from '@/views/resource/courseware'
import vedio from '@/views/resource/vedio'
import caseData from '@/views/resource/caseData'
import caseDataPage from '@/views/resource/details/caseDataPage'
import addquestionIndex from '@/views/resource/page/addquestionIndex'
import addvedioIndex from '@/views/resource/page/addvedioIndex'
import addcourseIndex from '@/views/resource/page/addcourseIndex'
import addcaseIndex from '@/views/resource/page/addcaseIndex'
import commonPackage from '@/views/coursePackage/commonPackage'
import classManage from '@/views/classCenter/classManage'
import StudentDetails from '@/views/classCenter/StudentDetails'
import StudyDetails from '@/views/classCenter/StudyDetails'
import courseAnalysis from '@/views/teachAnalysis/courseAnalysis'
import classAnalysis from '@/views/teachAnalysis/classAnalysis'
import studentManage from '@/views/studentCenter/studentManage'
export const constantRoutes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: login, hidden: true },
  {
    path: '/system', component: Layout, redirect: 'chapter',
    meta: { title: '系统设置', icon: 'icon-a-shezhi-shucaidanshezhi-copy' },
    children: [
      {
        path: 'rptTemplate', name: 'rptTemplate',
        component: () => import('@/views/system/rptTemplate'),
        meta: { title: '报告模板', icon: 'arrow-right' }
      },
      {
        path: 'chapter', name: 'chapter', component: chapter,
        meta: { title: '章节目录', icon: 'arrow-right' }
      },
      {
        path: 'professionChapter', name: 'professionChapter', component: professionChapter,
        meta: { title: '专业章节目录', icon: 'arrow-right' }
      }
    ]
  },

  {
    path: '/studentCenter', component: Layout, redirect: 'studentManage',
    meta: { title: '学生中心', icon: 'icon-icon_ems_protect_expert' },
    children: [
      {
        path: 'studentManage', name: 'studentManage', component: studentManage,
        meta: { title: '学生管理', icon: 'arrow-right' }
      },
      {
        path: 'StudentStudyDetails', component: StudyDetails, name: 'StudentStudyDetails',
        meta: { title: '学习详情', activeMenu: '/studentCenter/StudyDetails' }, hidden: true
      },
    ]
  },

  {
    path: '/resource',
    component: Layout,
    // redirect: '/resource/question',
    name: 'Resource',
    meta: { title: '教学资源中心', icon: 'icon-ziyuan' },
    children: [
      {
        path: 'question', component: question, name: 'question',
        meta: { title: '试题库管理', icon: 'arrow-right' }
      },
      {
        path: 'vedio', component: vedio, name: 'vedio',
        meta: { title: '视频库管理', icon: 'arrow-right' }
      },
      {
        path: 'courseware', component: courseware,  name: 'courseware',
        meta: { title: '课件库管理', icon: 'arrow-right' }
      },
      {
        path: 'caseData', component: caseData, name: 'caseData',
        meta: { title: '病例库管理', icon: 'arrow-right' }
      },
      {
        path: 'resourceManage', 
        component: () => import('@/views/resource/resourceManage'),
        name: 'resource', meta: { title: '资料库管理', icon: 'arrow-right' }
      },
      {
        path: 'addquestionIndex', component: addquestionIndex, name: 'addquestionIndex',
        meta: { title: '新增试题', activeMenu: '/resource/question' }, hidden: true
      },
      {
        path: 'addvedioIndex', component: addvedioIndex, name: 'addvedioIndex',
        meta: { title: '新增视频', activeMenu: '/resource/vedio' }, hidden: true
      },
      {
        path: 'addcourseIndex', component: addcourseIndex, name: 'addcourseIndex',
        meta: { title: '上传课件', activeMenu: '/resource/courseware' }, hidden: true
      },
      {
        path: 'addcaseIndex', component: addcaseIndex, name: 'addcaseIndex',
        meta: { title: '上传病例', activeMenu: '/resource/caseData' }, hidden: true
      },
      {
        path: 'addresourceIndex', 
        component: () => import('@/views/resource/page/addresourceIndex'),
        name: 'addresourceIndex', meta: { title: '上传资料', icon: 'arrow-right' }, hidden: true
      }
    ]
  },

  {
    path: '/coursePackage', component: Layout, redirect: 'commonPackage',
    meta: { title: '课程包中心', icon: 'icon-kecheng' },
    children: [
      {
        path: 'commonPackage', name: 'commonPackage', component: commonPackage,
        meta: { title: '专业课程管理', icon: 'arrow-right' }
      },
    ]
  },
  {
    path: '/classCenter', component: Layout, redirect: 'classManage',
    meta: { title: '班级中心', icon: 'icon-renqun' },
    children: [
      {
        path: 'classManage', name: 'classManage', component: classManage,
        meta: { title: '班级管理', icon: 'arrow-right' }
      },
      {
        path: 'StudentDetails', component: StudentDetails, name: 'StudentDetails',
        meta: { title: '学生详情', activeMenu: '/classCenter/classManage' }, hidden: true
      },
      {
        path: 'StudyDetails', component: StudyDetails, name: 'StudyDetails',
        meta: { title: '学习详情', activeMenu: '/classCenter/classManage' }, hidden: true
      },
    ]
  },
  {
    path: '/paperManage', component: Layout, redirect: 'paperManage',
    meta: { title: '考卷管理', icon: 'icon-kaojuanguanli' },
    children: [
      {
        path: 'readPaper', name: 'readPaper',
        component: () => import('@/views/paperManage/readPaper'),
        meta: { title: '读片考卷', icon: 'arrow-right' }
      },
      {
        path: 'readPaperMoudle', name: 'readPaperMoudle',
        component: () => import('@/views/paperManage/readPaperMoudle'),
        meta: { title: '新建读片考卷', activeMenu: '/paperManage/readPaper' }, hidden: true
      },
      {
        path: 'reportPaper', name: 'reportPaper',
        component: () => import('@/views/paperManage/reportPaper'),
        meta: { title: '报告考卷', icon: 'arrow-right' }
      },
      {
        path: 'reportPaperMoudle', name: 'reportPaperMoudle',
        component: () => import('@/views/paperManage/reportPaperMoudle'),
        meta: { title: '新建报告考卷', activeMenu: '/paperManage/reportPaper' }, hidden: true
      },
    ]
  },
  {
    path: '/examAnalysis', component: Layout, redirect: 'examAnalysis',
    meta: { title: '考试分析', icon: 'icon-kaoshifenxi' },
    children: [
      {
        path: 'readExam', name: 'readExam',
        component: () => import('@/views/paperManage/readExam'),
        meta: { title: '读片考试', icon: 'arrow-right' }
      },
      {
        path: 'readAnalysis', name: 'readAnalysis',
        component: () => import('@/views/paperManage/analysis/readAnalysis'),
        meta: { title: '读片考试分析', activeMenu: '/examAnalysis/readExam' }, hidden: true
      },
      {
        path: 'reportExam', name: 'reportExam',
        component: () => import('@/views/paperManage/reportExam'),
        meta: { title: '报告考试', icon: 'arrow-right' }
      }
    ]
  },
  {
    path: '/teachAnalysis', component: Layout, redirect: 'courseAnalysis',
    meta: { title: '教学数据中心', icon: 'icon-shujufenxi' },
    children: [
      {
        path: 'courseAnalysis', name: 'courseAnalysis', component: courseAnalysis,
        meta: { title: '课程分析', icon: 'arrow-right' }
      },
      {
        path: 'analysisdetail', name: 'analysisdetail',
        component: () => import('@/views/teachAnalysis/detail/index.vue'),
        meta: { title: '课程分析', activeMenu: '/teachAnalysis/courseAnalysis' }, hidden: true
      },
      {
        path: 'classAnalysis', name: 'classAnalysis', component: classAnalysis,
        meta: { title: '班级分析', icon: 'arrow-right' }
      },
    ]
  },
  { path: '/caseDataPage', component: caseDataPage, hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },

  // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js